import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Loader from './common/Loader';


function NotificationItem({notification, selectedYear}) {
  const isViewed = notification?.viewed === true;
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const orderYear = notification?.year;
  const hasOrderLink = Boolean(notification?.order);

  function ToggleExpand() {
    setIsExpanded(prevState => !prevState);
  }

  function OpenOrderPage(event) {
    event.stopPropagation();
    const year = orderYear == null ? null : String(orderYear);
    const currentYear = selectedYear == null ? null : String(selectedYear);
    if (year && year !== currentYear) {
      event.preventDefault();
      localStorage.setItem('selectedYear', year);
      navigate('/documents/order');
      navigate(0);
    }
  }

  return (
    <div
      className="m-3 p-3 product-in-cart position-relative"
      style={{ minHeight: '160px', height: 'auto' }}
      tabIndex={0}
      onClick={ToggleExpand}
      aria-expanded={isExpanded}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div className="pe-3 pb-4">
          <h6>{notification.type_display}</h6>
          <div className="mt-3 mb-3" style={isExpanded ? undefined : {display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
            <small>{notification.text}</small>
          </div>
          {hasOrderLink && (
            <div className="mb-3">
              <Link className="lk-link" to="/documents/order" onClick={OpenOrderPage}>
                Заказ и договор
              </Link>
            </div>
          )}
          {notification.attachment && (
            <div className="mb-3">
              <a
                className="lk-link"
                href={notification.attachment}
                onClick={(event) => event.stopPropagation()}
              >
                Скачать файл
              </a>
            </div>
          )}
        </div>
        <div className="ms-3">
          {isViewed ? (
            <span className="badge text-bg-secondary">Прочитано</span>
          ) : (
            <span className="badge text-bg-danger">Новое</span>
          )}
        </div>
      </div>
      <small className="position-absolute bottom-0 start-0 m-3 mt-5 text-muted">
        <strong>{notification.date_created}</strong>
      </small>
    </div>
  );
}


function UserNotifications({notifications, onOpen, loading, selectedYear}) {
  const notificationsList = Array.isArray(notifications) ? notifications : [];
  
  useEffect(() => {
    onOpen(notificationsList);

  }, [onOpen, notificationsList]);

  return loading ? (
    <Loader/>
  ) : (
    <>
      <div className="row">
        <h3 className="m-3">Уведомления</h3>
      </div>
      <div className="row">
        {notificationsList.length ? (
          <div className="col-xxl-8 col-10">
            {notificationsList.map(notification => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                selectedYear={selectedYear}
              />
            ))}
          </div>
        ) : (
          <div className="col-xxl-8 col-10">
            <p className="m-5 text-center">У вас пока нет уведомлений</p>
          </div>
        )}
      </div>
    </>
  );
}

export default UserNotifications;
